



















import { defineComponent, toRefs, PropType, computed } from '@vue/composition-api';
import { AdgroupFormData, BidStrategyType, SmartBidType } from '@tt4b/ttam-enums';
import TargetItem from '../target-item/index.vue';
import { displayMessageIfChangeBidStrategy, useLabel, useLabelTip } from '../hooks/unified-bid-strategy';
import { StrategyOption } from '../consts';
import { BidStrategy } from './../../../index';

const name = 'ttam-bid-strategy-target-cpa';
export default defineComponent({
  name,
  components: {
    TargetItem,
    TtamBidCapToCostCapTips: BidStrategy.TtamBidCapToCostCapTips,
  },
  props: {
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    originAdgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    strategyList: {
      type: Array as PropType<StrategyOption[]>,
      default: () => [],
    },
    showStrategyChangedMessage: {
      type: Boolean,
      default: false,
    },
    isBidCapToCostCapTipVisible: {
      type: Boolean,
      default: false,
    },
    requiredRules: {
      type: Array,
      default: () => [],
    },
    optionalRules: {
      type: Array,
      default: () => [],
    },
    disabledSwitch: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const {
      adgroupData,
      disabledSwitch,
      originAdgroupData,
      strategyList,
      requiredRules,
      optionalRules,
      showStrategyChangedMessage,
    } = toRefs(props);
    const isLowestCostSelected = computed(() => originAdgroupData.value.smartBidType === SmartBidType.NO_BID);
    const disabledInput = computed(() => disabledSwitch.value && isLowestCostSelected.value);
    const strategyListSelectable = computed(() => {
      if (!disabledSwitch.value) {
        return strategyList.value;
      }
      return isLowestCostSelected.value
        ? strategyList.value
        : strategyList.value.filter(item => item.value === originAdgroupData.value.smartBidType);
    });
    const optional = computed(() => strategyListSelectable.value.length > 1);
    const settableStrategy = computed(() => strategyListSelectable.value.find(item => item.hasBidSet));
    const setFormKey = computed(() => settableStrategy.value?.dataKey);
    let hasDisplayedMessage = false;
    const displayMessage = (val: number) => {
      const canShowMessage = !hasDisplayedMessage && showStrategyChangedMessage.value && optional.value;
      if (canShowMessage) {
        const status = displayMessageIfChangeBidStrategy({
          preVal: adgroupData.value?.[setFormKey.value] as number,
          curVal: val as number,
        });
        hasDisplayedMessage = status;
      }
    };
    const _bid = computed({
      get: () => (adgroupData.value?.[setFormKey.value] === 0 ? '' : adgroupData.value?.[setFormKey.value]),
      set: val => {
        if (val === adgroupData.value?.[setFormKey.value]) {
          return;
        }
        displayMessage(val);
        emit('bid-change', { [setFormKey.value]: val || 0 });
      },
    });
    const currentStrategy = computed(() => {
      if (optional.value) {
        return _bid.value
          ? settableStrategy.value
          : strategyListSelectable.value.find(item => [BidStrategyType.LOWEST_COST].includes(item.type));
      } else {
        return settableStrategy.value
          ? settableStrategy.value
          : strategyListSelectable.value.find(item => [BidStrategyType.LOWEST_COST].includes(item.type));
      }
    });
    const { label } = useLabel({
      adgroupData,
      settableStrategy,
    });
    const { labelTip } = useLabelTip({
      adgroupData,
      optional,
      settableStrategy,
    });

    const isSupportBidCap = computed(() =>
      Boolean(strategyListSelectable.value.find(item => item.type === BidStrategyType.BID_CAP)),
    );

    const rules = computed(() => (optional.value ? optionalRules.value : requiredRules.value));

    return {
      name,
      label,
      optional,
      settableStrategy,
      currentStrategy,
      _bid,
      labelTip,
      setFormKey,
      isSupportBidCap,
      rules,
      disabledInput,
    };
  },
});
